import {cn} from '@/lib/utils';
import {Fragment, ReactNode} from 'react';
type Props = {
  children?: ReactNode;
  length?: number;
};

export function formDummyRows(rowCount: number = 3) {
  const width = ['w-3/4', 'w-full', 'w-full', 'w-1/2', 'w-2/3'];
  const widthStyleList: string[] = [];
  for (let i = 0; i < rowCount; i++) {
    widthStyleList.push(width[i % width.length]);
  }
  return (
    <>
      {widthStyleList?.map((widthStyle, i) => {
        return (
          <div key={i} className={cn('bg-gray-100 rounded-full', widthStyle)}>
            &nbsp;
          </div>
        );
      })}
    </>
  );
}

export function LoadingItem({children, length = 10}: Props) {
  return (
    <>
      {Array.from({length}).map((_, i) => (
        <Fragment key={i}>
          <div className="fade-in-up w-full mb-[10px]" key={i}>
            <div className="animate-pulse w-full">{children}</div>
          </div>
        </Fragment>
      ))}
    </>
  );
}
